import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService, CartService } from "../../../_common/_service/user.service";
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { PaymentService } from '../payment/payment.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class cartComponent implements OnInit {
  serviceCode: any;
  VoucherCode: any;
  submitted = false;

  cUser: any;
  maxDate = new Date();
  currentUser: any;
  token: any;

  totalprice: any;
  loadingspinner: boolean = false;
  private orderCounter: number = 0;

  responsearray: any[] = [];


  responsearrayproductid: any[] = [];
  optionbtn: any;

  constructor(
    private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder, private _cartservice: CartService,
    private paymentService: PaymentService,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService) {


  }


  ngOnInit(): void {

    this.token = this.tokenStorageService.getToken();
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;

    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();

      if (this.serviceCode == null) {
        var parentproductidinarray = this._cartservice.getparentproductid();

        for (var i = 0; i < parentproductidinarray.length; i++) {
          this.getproductlistbyid(parentproductidinarray[i]);


        }



      }

    }
    else {
      this._service.callMethodOfSecondComponent();
    }


  }

  Back() {

    this.router.navigate(['/Go-on']);
  }




  removeProductToCart(ParentId: any) {

    this._cartservice.removeToCart(ParentId);

    this._cartservice.callMethodOfSecondComponent();

    this.responsearray = [];
    this.totalprice = 0;
    this.responsearrayproductid = [];

    var parentproductidinarray = this._cartservice.getparentproductid();

    for (var i = 0; i < parentproductidinarray.length; i++) {
      this.getproductlistbyid(parentproductidinarray[i]);
    }



  }


  // apiinarray() {
  //   debugger;

  //   // var productidinarray = this._cartservice.getparentproductid();

  //   if (this.optionbtn == null || this.optionbtn == undefined) {

  //     this.toastr.error("Choose Payment Option", 'Error');

  //   }

  //   else if (this.optionbtn == "paybyvoucher") {
  //     this.loadingspinner = true;
  //     this.submitted = true;
  //     if (!this.VoucherCode) {
  //       this.toastr.error("Enter Valid Voucher Code", 'Error');
  //       this.loadingspinner = false;
  //       return;
  //     }
  //     var post2 =
  //     {
  //       email: this.currentUser.email,
  //       amount: this.totalprice,
  //       productIds: this.responsearrayproductid,
  //       PromoCode: this.VoucherCode
  //     };

  //     debugger;
  //     this.authService.purchasedByPromoRequest(post2).subscribe((response: { apiStatus: boolean; apiMessage: any; apiData: any; transactionStatus: any }) => {

  //       this.loadingspinner = false;
  //       if (response.apiStatus == true) {
  //         this.totalprice = 0;
  //         this.responsearray = [];
  //         this.responsearrayproductid = [];

  //         this._cartservice.removeToCartafterurl();

  //         this.toastr.success(response.apiMessage, 'Success');
  //         location.reload();
  //       }
  //       else {
  //         this.toastr.error(response.apiMessage, 'Error');
  //       }
  //     }, (err: any) => {
  //       this.loadingspinner = false;
  //       if (err.error instanceof Error) {

  //         this.toastr.error(err.error, 'Error');
  //       } else {

  //         this.toastr.error(err.error, 'Error');
  //       }
  //     });
  //   }


  //   else {
  //     this.loadingspinner = true;
  //     var post =
  //     {
  //       email: this.currentUser.email,
  //       amount: this.totalprice,
  //       accountServiceId: null,
  //       productIds: this.responsearrayproductid,
  //       flag: this.optionbtn
  //     };

  //     debugger;
  //     this.authService.addMoneyRequestupi(post).subscribe((response: { apiStatus: boolean; apiMessage: any; apiData: any; transactionStatus: any }) => {

  //       this.loadingspinner = false;
  //       if (response.apiStatus == true) {
  //         this.totalprice = 0;
  //         this.responsearray = [];
  //         this.responsearrayproductid = [];

  //         this._cartservice.removeToCartafterurl();

  //         location.href = response.apiData.Url;

  //       }
  //       else {
  //         this.toastr.error(response.apiMessage, 'Error');
  //       }
  //     }, (err: any) => {
  //       this.loadingspinner = false;
  //       if (err.error instanceof Error) {

  //         this.toastr.error(err.error, 'Error');
  //       } else {

  //         this.toastr.error(err.error, 'Error');
  //       }
  //     });
  //   }


  // }

  apiinarray() {
    const orderId = this.generateTransactionId();
    const payableAmount = this.totalprice ? Number(this.totalprice).toFixed(2) : "0";
    const payload = {
      appid: "ZEpNIaTHy20250923123246158",
      merchantId: "devendra.kumar@zenithguard.in",
      orderId,
      payableAmount,
      txnType: "PAYIN",
      countryCode: "IN",
      currencyCode: "INR",
      firstname: "Devendra",
      lastname: "Kumar",
      emailId: "devendra.kumar@example.com",
      mobileNo: "9716184021",
      return_url: "https://webhook.site/f1f40ba5-2a50-420e-b4ae-6f093d4ac6ae",
      cancel_url: "https://webhook.site/f1f40ba5-2a50-420e-b4ae-6f093d4ac6ae",
      callback_url: "https://webhook.site/f1f40ba5-2a50-420e-b4ae-6f093d4ac6ae",
      paymentMode: "ONLINE",
      paymentRemarks: "Payment for invoice amazon",
      clientIP: "",
      udf1: "CustomField1",
      udf2: "CustomField2",
      udf3: "CustomField3",
      udf4: "CustomField4",
      udf5: "CustomField5"
    };
 
   this.paymentService.createOrder(payload).subscribe({
    next: (res: any) => {
      console.log("ORDER RESPONSE:", res);
 
      const paymentLink = res?.paymentlink ?? res?.data?.paymentlink;
      if (paymentLink) {
        window.open(paymentLink, '_blank', 'noopener,noreferrer');
      } else {
        this.toastr.error("Payment link not received");
      }
    },
    error: (err) => {
      console.error("API Error:", err);
      this.toastr.error("Failed to create order");
    }
  });
  }

  private generateTransactionId(): string {
    const now = new Date();

    const pad = (value: number, length: number): string =>
      value.toString().padStart(length, '0');

    const year = now.getUTCFullYear();
    const month = pad(now.getUTCMonth() + 1, 2);
    const day = pad(now.getUTCDate(), 2);
    const hours = pad(now.getUTCHours(), 2);
    const minutes = pad(now.getUTCMinutes(), 2);
    const seconds = pad(now.getUTCSeconds(), 2);
    const millis = pad(now.getUTCMilliseconds(), 3);

    const timestamp = `${year}${month}${day}${hours}${minutes}${seconds}${millis}`; // 17 digits

    // 2-digit sequence per session
    this.orderCounter = this.orderCounter >= 99 ? 0 : this.orderCounter + 1;
    const seq = pad(this.orderCounter, 2);

    const numericId = (timestamp + seq).substring(0, 15); // 15 digits

    // Match your earlier pattern: ORD + numeric id
    return `ORD${numericId}`;
  }


  getproductlistbyid(catgoryid: any) {
    this.loadingspinner = true;
    var body = {
      categoryId: parseFloat(catgoryid)

    }
    this.authService.getproductlistbyid(body).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      this.loadingspinner = false;
      if (response.apiStatus == true) {
        //this.responsearray = response.apiData;

        //this.productid = response.apiData.Id;
        //this.productname = response.apiData.Name;
        //this.productprice = response.apiData.OtherDetails.Price;

        this.responsearray.push(response.apiData);
        //console.log(this.responsearray);
        //this.totalprice = response.apiData.OtherDetails.Price;
        //console.log(parseInt(this.totalprice) + parseInt(response.apiData.OtherDetails.Price));

        //this.productid = response.apiData.Id;
        //this.productname = response.apiData.Name;
        //this.productprice = response.apiData.OtherDetails.Price;
        this.totalpric();
        this.totalproductId();
      }
      else if (response.apiStatus == false) {
        //    "apiMessage": "user account is disable",
        //this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  totalpric() {
    var total = 0;
    this.responsearray.forEach((item: any) => {
      total += parseFloat(item.OtherDetails.Price == undefined ? 0 : item.OtherDetails.Price);

      //total += parseFloat(item.OtherDetails.GstAmount == undefined ? 0 : item.OtherDetails.GstAmount);
    })
    this.totalprice = total;
  }

  ConToparseFloat(val: any) {
    return parseFloat(val);
  }

  totalproductId() {

    this.responsearray.forEach((item: any) => {
      if (!this.responsearrayproductid.includes(item.Id)) {
        this.responsearrayproductid.push(item.Id);
      }

    })

  }



  changeMethod(event: any) {


    this.optionbtn = event.value;
    if (this.optionbtn == "paybyvoucher") {

    }

  }

}
